import { useEffect } from "react";

/**
 * Adds 'in-view' class to elements with .fade-up when they enter viewport.
 */
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".fade-up");
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
